import { ComponentBackgroundColor } from "types/componentBackground";

const backgrounds: ComponentBackgroundColor[] = ["neutral05", "white"];
let currentColor: ComponentBackgroundColor;
let nextColor: ComponentBackgroundColor;

export function getBackground(): ComponentBackgroundColor {
  currentColor = nextColor;
  nextColor =
    backgrounds[(backgrounds.indexOf(currentColor) + 1) % backgrounds.length];

  return currentColor;
}

export function getCurrentBackground(): ComponentBackgroundColor {
  return currentColor || "white";
}

export function getCurrentOppositeColor(): ComponentBackgroundColor {
  return nextColor;
}

export function forceNextBackground(color: ComponentBackgroundColor): void {
  nextColor = color;
}
